"use strict";

if (typeof window !== "undefined") {
  window.salla = window.salla || window.Salla || {};
  window.Salla = window.salla;
}
if (typeof global !== "undefined") {
    //@ts-ignore
    global.salla = global.salla || global.Salla || {};
    //@ts-ignore
    global.Salla =global.salla;
}

// loading helpers object and link it to salla
import Helpers from "./helpers"
import Logger from "./logger"
import Config from "./config"
import Emitter from "./event"
import Storage from "./storage"
import Cookie from "./cookie"

Salla.status = 'base';
// const Salla = {};
Salla.config = new Config();
Salla.logger = Logger;
Salla.event = new Emitter();
Salla.helpers = Helpers;
Salla.storage = new Storage();
Salla.cookie = new Cookie();

// alias
Salla.log = Salla.logger.log;
Salla.money = Salla.helpers.money;
Salla.url = Salla.helpers.url;
Salla.versions = {
  base: '[BASE-VI]{version}[/BASE-VI]'
};

export default Salla